import { useCallback, useEffect } from 'react';

import { Close } from '@mui/icons-material';
import {
  Alert,
  AlertColor,
  IconButton,
  Snackbar,
  Tooltip,
} from '@mui/material';

import { useSnackContext } from 'hooks/useSnackContext';

export type SnackProps = {
  open: boolean;
  duration: number;
  severity: AlertColor;
  message: string;
  error?: Error;
};

export const defaultSnackProps: SnackProps = {
  open: false,
  duration: 10000,
  severity: 'error',
  message: 'An Unknown Error Has Occurred',
};

export const Snack = () => {
  const {
    snack: { message, open, severity, duration },
    setSnack,
  } = useSnackContext();

  const handleClose = useCallback(async () => {
    setSnack((props) => ({ ...props, open: false }));
  }, [setSnack]);

  useEffect(() => {
    if (open) {
      severity === 'warning' ? console.warn(message) : void 0;
      severity === 'error' ? console.error(message) : void 0;
    }
  }, [setSnack, open, severity, message]);
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={() => setSnack((props) => ({ ...props, open: false }))}
    >
      <Alert
        severity={severity}
        variant='filled'
        action={
          <Tooltip title='close'>
            <IconButton onClick={handleClose}>
              <Close sx={{ color: 'white' }} />
            </IconButton>
          </Tooltip>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
